module.exports = __webpack_public_path__ + "static/media/SmartphoneiPhone.2b7fc472.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/SmartphoneiPhone.png
// module id = 804
// module chunks = 1 3